export default function PetDetailsModal({pet, onClose, addToFavorites, quizAnswers, matchScore}) {
  
  // Generate match reasons based on quiz answers
  const getMatchReasons = () => {
    const reasons = [];
    
    // Size match
    if (quizAnswers[0] === pet.size) {
      reasons.push(`You prefer ${pet.size.toLowerCase()} - ${pet.name} is a perfect size!`);
    }
    
    // Activity match
    if (quizAnswers[1] === pet.activityLevel) {
      reasons.push(`Your ${pet.activityLevel.toLowerCase()} lifestyle matches perfectly`);
    }
    
    // Time match
    if (quizAnswers[2] === pet.timeNeeded) {
      reasons.push(`Your ${pet.timeNeeded.toLowerCase()} daily time commitment is ideal`);
    }
    
    // Children compatibility
    if (quizAnswers[5] !== "No children" && pet.goodWith.includes("children")) {
      reasons.push(`${pet.name} is great with children!`);
    }
    
    // Other pets
    if (quizAnswers[8] === "Have dogs" && pet.goodWith.includes("dogs")) {
      reasons.push(`${pet.name} gets along well with other dogs`);
    }
    
    // Training match
    if (pet.training === "Well trained" && quizAnswers[4] === "First-time owner") {
      reasons.push(`Perfect for first-time owners with ${pet.training.toLowerCase()}`);
    }
    
    return reasons;
  };

  const matchReasons = getMatchReasons();

  return (
     <div className="modal-overlay">
      <div className="modal-content">
          <button className="close-button" onClick={onClose}>✕</button>
          
          <img 
            className="modal-pet-image"
            src={pet.image} 
            alt={`${pet.breed} named ${pet.name}`}
          />
          <h3 className="modal-pet-name">{pet.name}</h3>
          <p className="modal-pet-info">{pet.age} years old • {pet.breed} • {pet.type}</p>
          <p className="modal-pet-description">
            {pet.name} is looking for a loving home! This {pet.breed} is {pet.activityLevel.toLowerCase()} and {pet.training.toLowerCase()}.
          </p>

          <div className="personality-badges">
            {pet.goodWith.includes("children") && <span className="badge">🏠 Family-Friendly</span>}
            {pet.activityLevel === "Very Active" && <span className="badge">🎾 Playful</span>}
            {pet.noise === "Silent is golden" && <span className="badge">🤫 Quiet</span>}
          </div>
          
          <div className="match-reasons">
            <h4>Why {pet.name} is Your Perfect Match:</h4>
            <ul>
              {matchReasons.map((reason, index) => (
                <li key={index}>✓ {reason}</li>
              ))}
            </ul>
          </div>

          <div className="additional-info">
            <h4>Additional Information:</h4>
            <p><strong>Health:</strong> Up-to-date on vaccinations, neutered</p>
            <p><strong>Training:</strong> House-trained, knows basic commands</p>
            <p><strong>Good with:</strong> Children, other dogs, cats</p>
            <p><strong>Adoption fee:</strong> $250 (includes microchip)</p>
          </div>
          
          <p className="modal-match-percentage">{matchScore}% Match!</p>
          
          <div className="modal-buttons">
            <button onClick={() => addToFavorites(pet)} className="favorite-button">Add To Favorites ❤️</button>
          </div>
      </div>
    </div>
  )
}